document.addEventListener('DOMContentLoaded',()=>{

  const counters = document.querySelectorAll('.asia24-stat__number');

  const runCounter = (counter)=>{

    const target = parseInt(counter.dataset.target);

    let current = 0;

    const increment = Math.ceil(target / 100);

    const timer = setInterval(()=>{

      current += increment;

      if(current >= target){

        current = target;
        clearInterval(timer);

      }

      counter.textContent =
        current.toLocaleString();

    },20);

  };

  const observer = new IntersectionObserver((entries)=>{

    entries.forEach(entry=>{

      if(entry.isIntersecting){

        runCounter(entry.target);

        observer.unobserve(entry.target);

      }

    });

  });

  counters.forEach(counter=>{
    observer.observe(counter);
  });

});